import { IconBuildingWarehouse, IconBook, IconUsers } from '@tabler/icons-react';

import { colors } from 'constants/colors';
import { TotadminPermission } from 'data/__generated__';

import { CgScreenWide } from 'react-icons/cg';
import { FaAppleAlt, FaCoffee, FaHandshake, FaThermometerHalf, FaTruckLoading, FaUtensils } from 'react-icons/fa';
import {
    FcAreaChart,
    FcBarChart,
    FcCalendar,
    FcCancel,
    FcConferenceCall,
    FcCurrencyExchange,
    FcDataConfiguration,
    FcDataRecovery,
    FcDebt,
    FcDeployment,
    FcDonate,
    FcExpired,
    FcFilledFilter,
    FcGrid,
    FcInTransit,
    FcInvite,
    FcKey,
    FcList,
    FcMoneyTransfer,
    FcNeutralTrading,
    FcNews,
    FcOrganization,
    FcPaid,
    FcPlanner,
    FcSettings,
    FcShop,
    FcSms,
    FcStackOfPhotos,
    FcCalculator,
    FcCamera,
    FcInspection,
    FcAdvertising,
} from 'react-icons/fc';
import { BsFillQuestionDiamondFill } from 'react-icons/bs';
import { RiExchangeBoxLine, RiFridgeFill } from 'react-icons/ri';
import { IoBicycleOutline } from 'react-icons/io5';
import { GrPlan } from 'react-icons/gr';

enum PageName {
    advertisementScreenConfig = 'advertisementScreenConfig',
    audit = 'audit',
    auditDetails = 'auditDetails',
    ntfy = 'ntfy',
    advertisementScreenConfigLoggedOut = 'advertisementScreenConfigLoggedOut',
    badges = 'badges',
    badgeCreate = 'badgeCreate',
    badgeUpdate = 'badgeUpdate',
    bakeryRecords = 'bakeryRecords',
    basket = 'basket',
    bundles = 'bundles',
    bundleDetails = 'bundleDetails',
    categories = 'categories',
    categoryCreate = 'categoryCreate',
    categoryDetails = 'categoryDetails',
    credits = 'credits',
    creditCreate = 'creditCreate',
    creditDetails = 'creditDetails',
    comments = 'comments',
    deliveries = 'deliveries',
    deliveriesDailyPhoto = 'deliveriesDailyPhoto',
    deliveryPlanning = 'deliveryPlanning',
    deliveryPlanningSelectedDate = 'deliveryPlanningSelectedDate',
    deliveryPlanningAudit = 'deliveryPlanningAudit',
    dynamicDeliveryPlanning = 'dynamicDeliveryPlanning',
    dynamicDeliveryPlanningSelectedDate = 'dynamicDeliveryPlanningSelectedDate',
    tours = 'tours',
    toursSelectedDate = 'toursSelectedDate',
    tourDetails = 'tourDetails',
    deliveryDetails = 'deliveryDetails',
    forgotPassword = 'forgotPassword',
    resetPassword = 'resetPassword',
    expiredFutureStockVariations = 'expiredFutureStockVariations',
    expiryDateRecords = 'expiryDateRecords',
    equipments = 'equipments',
    equipmentDetails = 'equipmentDetails',
    equipmentCreate = 'equipmentCreate',
    futureStockVariations = 'futureStockVariations',
    trayCapacities = 'trayCapacities',
    hotDrinksRecipes = 'hotDrinksRecipes',
    hotDrinksRecipeDetails = 'hotDrinksRecipeDetails',
    hotDrinksRecipeCreate = 'hotDrinksRecipeCreate',
    locations = 'locations',
    supplierPartnerships = 'supplierPartnerships',
    manualSupplyOrders = 'manualSupplyOrders',
    menus = 'menus',
    menusDetails = 'menusDetails',
    menuQuantities = 'menuQuantities',
    menuProductArrangements = 'menuProductArrangements',
    messagesSets = 'messagesSets',
    messagesSetsCreate = 'messagesSetsCreate',
    messagesSetDetails = 'messagesSetDetails',
    microstoreColumns = 'microstoreColumns',
    microstoreColumnDetails = 'microstoreColumnDetails',
    microstoreColumnGroups = 'microstoreColumnGroups',
    microstoreColumnGroupDetails = 'microstoreColumnGroupDetails',
    microstoreColumnGroupTargetsInfo = 'microstoreColumnGroupTargetsInfo',
    microstoreColumnTemplates = 'microstoreColumnTemplates',
    microstoreColumnTemplateDetails = 'microstoreColumnTemplateDetails',
    microstorePlanogram = 'microstorePlanogram',
    microstoreSnapshot = 'microstoreSnapshot',
    mobilePopups = 'mobilePopups',
    notifications = 'notifications',
    notificationsOrganization = 'notificationsOrganization',
    notificationsSite = 'notificationsSite',
    notificationsUser = 'notificationsUser',
    opsParameters = 'opsParameters',
    orders = 'orders',
    orderCreate = 'orderCreate',
    orderDetails = 'orderDetails',
    organizations = 'organizations',
    organizationDetails = 'organizationDetails',
    organizationCreate = 'organizationCreate',
    payments = 'payments',
    paymentDetails = 'paymentDetails',
    paymentMethodDetails = 'paymentMethodDetails',
    totems = 'totems',
    totemDetails = 'totemDetails',
    microstoreColumnGroupPage = 'microstoreColumnGroupPage',
    polls = 'polls',
    pollCreate = 'pollCreate',
    pollDetails = 'pollDetails',
    products = 'products',
    productCreate = 'productCreate',
    productArrangements = 'productArrangements',
    productGroups = 'productGroups',
    productGroupDetails = 'productGroupDetails',
    productArrangementDetails = 'productArrangementDetails',
    productDetails = 'productDetails',
    productImport = 'productImport',
    productPriceRangeCreate = 'productPriceRangeCreate',
    productPriceRangeDetails = 'productPriceRangeDetails',
    permissionGroups = 'permissionGroups',
    permissionGroupDetails = 'permissionGroupDetails',
    priceInvisibilityRules = 'priceInvisibilityRules',
    priceInvisibilityRuleDetails = 'priceInvisibilityRuleDetails',
    productPriceRanges = 'productPriceRanges',
    quizzes = 'quizzes',
    quizCreate = 'quizCreate',
    quizDetails = 'quizDetails',
    ritualCreate = 'ritualCreate',
    ritualDetails = 'ritualDetails',
    rituals = 'rituals',
    ritualTemplates = 'ritualTemplates',
    settings = 'settings',
    sites = 'sites',
    siteCreate = 'siteCreate',
    siteImport = 'siteImport',
    siteDetails = 'siteDetails',
    siteMicrostoreColumnGroups = 'siteMicrostoreColumnGroups',
    siteExternalInventory = 'siteExternalInventory',
    siteSetups = 'siteSetups',
    siteSetupDetails = 'siteSetupDetails',
    siteStocks = 'siteStocks',
    stockTransfers = 'stockTransfers',
    stockTransferCreate = 'stockTransferCreate',
    stockTransferDetails = 'stockTransferDetails',
    stockTransferReturns = 'stockTransferReturns',
    stocks = 'stocks',
    siteInventoryStockCreate = 'siteInventoryStockCreate',
    stockVariationCreate = 'stockVariationCreate',
    stockVariationMultiCreate = 'stockVariationMultiCreate',
    stockVariationsByDay = 'stockVariationsByDay',
    columnStocks = 'columnStocks',
    columnProductStocks = 'columnProductStocks',
    mealPlanDefinitions = 'mealPlanDefinitions',
    mealPlanDefinitionCreate = 'mealPlanDefinitionCreate',
    mealPlanDefinitionDetails = 'mealPlanDefinitionDetails',
    subventions = 'subventions',
    subventionCreate = 'subventionCreate',
    subventionDetails = 'subventionDetails',
    suppliers = 'suppliers',
    supplierCreate = 'supplierCreate',
    supplierDetails = 'supplierDetails',
    supplyOrders = 'supplyOrders',
    supplyOrderDetails = 'supplyOrderDetails',
    supplyOrderConfirmation = 'supplyOrderConfirmation',
    supplierDiscounts = 'supplierDiscounts',
    tags = 'tags',
    tagCreate = 'tagCreate',
    tagUpdate = 'tagUpdate',
    tickets = 'tickets',
    ticketDetails = 'ticketDetails',
    thermometers = 'thermometers',
    transactions = 'transactions',
    transactionCreate = 'transactionCreate',
    transactionDetails = 'transactionDetails',
    termsRecords = 'termsRecords',
    termsRecordCreate = 'termsRecordCreate',
    totemClosedDays = 'totemClosedDays',
    totemClosedReceptionDays = 'totemClosedReceptionDays',
    urbantzRoundPresets = 'urbantzRoundPresets',
    users = 'users',
    userCreateToteam = 'userCreateToteam',
    userCreatedTotops = 'userCreatedTotops',
    userDetails = 'userDetails',
    setPassword = 'setPassword',
    passwordDefined = 'passwordDefined',
    warehouseDeliveries = 'warehouseDeliveries',
    warehouseDeliveryDetails = 'warehouseDeliveryDetails',
    warehouseReturns = 'warehouseReturns',
    warehouseReturnDetails = 'warehouseReturnDetails',
    nayaxMDBTemplates = 'nayaxMDBTemplates',
    nayaxMDBTemplateDetails = 'nayaxMDBTemplateDetails',
    deliveryZones = 'deliveryZones',
    deliveryZoneDetails = 'deliveryZoneDetails',
}

export enum NavSection {
    WarehouseManagementSystem = 'WarehouseManagementSystem',
    CatalogManagementSystem = 'CatalogManagementSystem',
    CustomerManagementSystem = 'CustomerManagementSystem',
}

export const NAV_SECTION_LABELS = {
    [NavSection.WarehouseManagementSystem]: 'Warehouse Management System',
    [NavSection.CatalogManagementSystem]: 'Catalog Management System',
    [NavSection.CustomerManagementSystem]: 'Customer Management System',
};

export const NAV_SECTION_ICONS = {
    [NavSection.WarehouseManagementSystem]: <IconBuildingWarehouse />,
    [NavSection.CatalogManagementSystem]: <IconBook />,
    [NavSection.CustomerManagementSystem]: <IconUsers />,
};

export type PageType = {
    icon?: JSX.Element;
    label: string;
    section: PageName;
    shortLabel?: string;
    url: string;
    navSection?: NavSection;
    /**
     * Le droit fin qui ouvre la page — et donc sa route, son entrée de menu et de palette. OBLIGATOIRE :
     * une page ajoutée sans cette décision ne compile pas. `null` = page publique (hors `AuthGuard`).
     * Une page de détail porte la lecture de sa liste, une page de création la gestion.
     */
    permission: TotadminPermission | null;
    /** Droits supplémentaires sans lesquels la DONNÉE PRINCIPALE de la page ne se charge pas (tous requis). */
    alsoRequires?: readonly TotadminPermission[];
};

export const PAGES: Record<PageName, PageType> = {
    advertisementScreenConfig: {
        icon: <CgScreenWide />,
        label: 'Écran publicitaire',
        section: PageName.advertisementScreenConfig,
        url: '/advertisement-screen-config',
        permission: TotadminPermission.AdvertisementScreensManage,
        navSection: NavSection.CustomerManagementSystem,
    },
    advertisementScreenConfigLoggedOut: {
        label: 'Écran publicitaire',
        section: PageName.advertisementScreenConfig,
        url: '/advertisement-screen-config/logged-out',
        permission: null,
    },
    badges: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badges',
        permission: TotadminPermission.BadgesRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    badgeCreate: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badge/create',
        permission: TotadminPermission.BadgesManage,
    },
    badgeUpdate: {
        icon: <FcFilledFilter />,
        label: 'Badges',
        section: PageName.badges,
        url: '/badge/:badgeId',
        permission: TotadminPermission.BadgesRead,
    },
    bakeryRecords: {
        icon: <>🥐</>,
        label: 'Suivi de cuisson viennoiseries',
        section: PageName.bakeryRecords,
        url: '/bakery-records',
        permission: TotadminPermission.StockRecordsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    bundles: {
        icon: <FcDeployment />,
        label: 'Bundles',
        section: PageName.bundles,
        url: '/bundles',
        permission: TotadminPermission.BundlesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    bundleDetails: {
        icon: <FcDeployment />,
        label: "Détails d'un bundle",
        section: PageName.bundles,
        url: '/bundle/:bundleId',
        permission: TotadminPermission.BundlesRead,
    },
    categories: {
        icon: <FcList />,
        label: 'Catégories',
        section: PageName.categories,
        url: '/categories',
        permission: TotadminPermission.CategoriesRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    categoryCreate: {
        icon: <FcList />,
        label: 'Créer une catégorie',
        section: PageName.categories,
        url: '/category/create',
        permission: TotadminPermission.CategoriesManage,
    },
    categoryDetails: {
        icon: <FcList />,
        label: "Détails d'une catégorie",
        section: PageName.categories,
        url: '/category/:categoryId',
        permission: TotadminPermission.CategoriesRead,
    },
    credits: {
        icon: <FcDonate />,
        label: 'Crédits',
        section: PageName.credits,
        url: '/credits',
        permission: TotadminPermission.CreditsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    creditCreate: {
        icon: <FcDonate />,
        label: 'Créer un crédit',
        section: PageName.credits,
        url: '/credit/create',
        permission: TotadminPermission.CreditsGrant,
    },
    creditDetails: {
        icon: <FcDonate />,
        label: "Détails d'un crédit",
        section: PageName.credits,
        url: '/credit/:creditId',
        permission: TotadminPermission.CreditsRead,
    },
    comments: {
        icon: <FcConferenceCall />,
        label: 'Commentaires',
        section: PageName.comments,
        url: '/comments',
        permission: TotadminPermission.CommentsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    deliveries: {
        icon: <FcInTransit />,
        label: 'Livraisons',
        section: PageName.deliveries,
        url: '/deliveries',
        permission: TotadminPermission.DeliveriesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveriesDailyPhoto: {
        icon: <FcCamera />,
        label: 'Contrôle de photos',
        section: PageName.deliveriesDailyPhoto,
        url: '/deliveries-daily-photos',
        permission: TotadminPermission.DeliveriesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryPlanning: {
        icon: <FcPlanner />,
        label: 'Planning de livraison',
        section: PageName.deliveryPlanning,
        url: '/delivery-planning',
        permission: TotadminPermission.DeliveryPlanningRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    tours: {
        icon: <FcInTransit />,
        label: 'Tournées',
        section: PageName.tours,
        url: '/tours',
        permission: TotadminPermission.ToursRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    toursSelectedDate: {
        label: 'Tournées',
        section: PageName.tours,
        url: '/tours/:selectedDate',
        permission: TotadminPermission.ToursRead,
    },
    tourDetails: {
        icon: <FcInTransit />,
        label: "Détails d'une tournée",
        section: PageName.tours,
        url: '/tour/:tourId',
        permission: TotadminPermission.ToursRead,
    },
    deliveryPlanningSelectedDate: {
        label: 'Planning de livraison',
        section: PageName.deliveryPlanning,
        url: '/delivery-planning/:selectedDate',
        permission: TotadminPermission.DeliveryPlanningRead,
    },
    deliveryPlanningAudit: {
        label: 'Historique du planning de livraison',
        section: PageName.deliveryPlanning,
        // Segment STATIQUE : React Router le classe avant `/:selectedDate`, qui attend une date.
        url: '/delivery-planning/historique',
        permission: TotadminPermission.DeliveryPlanningRead,
    },
    dynamicDeliveryPlanning: {
        icon: <FcPlanner />,
        label: 'Planning de livraison dynamique',
        section: PageName.dynamicDeliveryPlanning,
        url: '/dynamic-delivery-planning',
        permission: TotadminPermission.DeliveryPlanningRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    dynamicDeliveryPlanningSelectedDate: {
        label: 'Planning de livraison dynamique',
        section: PageName.dynamicDeliveryPlanning,
        url: '/dynamic-delivery-planning/:selectedDate',
        permission: TotadminPermission.DeliveryPlanningRead,
    },
    deliveryDetails: {
        icon: <FcInTransit />,
        label: "Détails d'une livraison",
        section: PageName.deliveries,
        url: '/delivery/:deliveryId',
        permission: TotadminPermission.DeliveriesRead,
    },
    equipments: {
        icon: <FaCoffee color={colors.blueOutline} />,
        label: 'Équipements',
        section: PageName.equipments,
        url: '/equipments',
        permission: TotadminPermission.EquipmentsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    equipmentDetails: {
        label: "Détails d'un équipement",
        section: PageName.equipments,
        url: '/equipment/:equipmentId',
        permission: TotadminPermission.EquipmentsRead,
    },
    equipmentCreate: {
        label: "Création d'un équipement",
        section: PageName.equipments,
        url: '/equipment/create',
        permission: TotadminPermission.EquipmentsManage,
    },
    expiredFutureStockVariations: {
        label: 'Variations de stock à venir expirées',
        section: PageName.stocks,
        url: '/stock-variation/expired-future-stock-variations',
        permission: TotadminPermission.StockVariationsRead,
    },
    expiryDateRecords: {
        icon: <FcExpired />,
        label: 'Date limite de consommation',
        section: PageName.expiryDateRecords,
        shortLabel: 'DLC',
        url: '/expiry-date-records',
        permission: TotadminPermission.StockRecordsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    forgotPassword: {
        label: 'Mot de passe oublié',
        section: PageName.forgotPassword,
        url: '/recover-password',
        permission: null,
    },
    resetPassword: {
        label: 'Réinitialiser le mot de passe',
        section: PageName.resetPassword,
        url: '/recover-password/:token',
        permission: null,
    },
    futureStockVariations: {
        icon: <FcAreaChart />,
        label: 'Variations de stock à venir',
        section: PageName.stocks,
        url: '/stock-variation/future-stock-variations',
        permission: TotadminPermission.StockVariationsRead,
    },
    trayCapacities: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Capacités Bacs',
        shortLabel: 'Bacs',
        section: PageName.trayCapacities,
        url: '/tray-capacities',
        permission: TotadminPermission.TrayCapacitiesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    hotDrinksRecipes: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Recettes Machine à Café',
        shortLabel: 'Recettes Machine à Café',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipes',
        permission: TotadminPermission.ProductsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    hotDrinksRecipeDetails: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Recette Machine à Café',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipe/:hotDrinksRecipeId',
        permission: TotadminPermission.ProductsRead,
    },
    hotDrinksRecipeCreate: {
        icon: <FaCoffee color={colors.orange} />,
        label: 'Créer une recette',
        section: PageName.hotDrinksRecipes,
        url: '/hot-drinks-recipe/create',
        permission: TotadminPermission.ProductsManage,
    },
    locations: {
        icon: <FcGrid />,
        label: 'Emplacements entrepôt',
        section: PageName.locations,
        shortLabel: 'Emplacements',
        url: '/locations',
        permission: TotadminPermission.WarehouseLocationsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    supplierPartnerships: {
        icon: <RiExchangeBoxLine />,
        label: 'Trades Marketing',
        section: PageName.supplierPartnerships,
        url: '/supplier-partnerships',
        permission: TotadminPermission.SuppliersRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    manualSupplyOrders: {
        icon: <FcCalculator />,
        label: 'Achats manuels',
        section: PageName.manualSupplyOrders,
        url: '/manual-supply-orders',
        permission: TotadminPermission.SupplyOrdersRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    menus: {
        icon: <FcCalendar />,
        label: 'Menus store',
        section: PageName.menus,
        shortLabel: 'Menus',
        url: '/menus',
        permission: TotadminPermission.MenusRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    menusDetails: {
        icon: <FcCalendar />,
        label: 'Détail menus store',
        section: PageName.menus,
        url: '/menus-details/:siteId/:selectedDate',
        permission: TotadminPermission.MenusRead,
    },
    menuQuantities: {
        icon: <FcCalendar />,
        label: 'Quantités menus store',
        section: PageName.menus,
        url: '/menu-quantities/:selectedDate',
        permission: TotadminPermission.MenusRead,
    },
    menuProductArrangements: {
        icon: <FcCalendar />,
        label: 'Arrangements menus store',
        section: PageName.menuProductArrangements,
        url: '/menu-product-arrangements/:selectedDate',
        permission: TotadminPermission.MenusRead,
    },
    messagesSets: {
        icon: <FcSms />,
        label: 'Séries de messages',
        section: PageName.messagesSets,
        shortLabel: 'Messages Rituels',
        url: '/messages-sets',
        permission: TotadminPermission.MessagesSetsRead,
    },
    messagesSetsCreate: {
        icon: <FcSms />,
        label: 'Créer une série de messages',
        section: PageName.messagesSets,
        shortLabel: 'Messages Rituels',
        url: '/messages-sets/create',
        permission: TotadminPermission.MessagesSetsManage,
    },
    messagesSetDetails: {
        icon: <FcSms />,
        label: 'Détails de la série',
        section: PageName.messagesSetDetails,
        shortLabel: 'Détails Messages',
        url: '/messages-set/:messagesSetId',
        permission: TotadminPermission.MessagesSetsRead,
    },
    microstoreColumns: {
        icon: <FcDataRecovery />,
        label: 'Colonnes microstore',
        section: PageName.microstoreColumns,
        shortLabel: 'MS Colonnes',
        url: '/microstore-columns',
        permission: TotadminPermission.MicrostoreColumnsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    microstoreColumnDetails: {
        icon: <FcDataRecovery />,
        label: "Détails d'une MS colonne",
        section: PageName.microstoreColumns,
        url: '/microstore-column/:microstoreColumnId',
        permission: TotadminPermission.MicrostoreColumnsRead,
    },
    microstoreColumnGroups: {
        icon: <FcDataRecovery />,
        label: 'Groupe de microstore colonnes',
        section: PageName.microstoreColumnGroups,
        shortLabel: 'MS Groupes',
        url: '/microstore-column-groups',
        permission: TotadminPermission.MicrostoreColumnGroupsRead,
        alsoRequires: [TotadminPermission.SitesRead],
        navSection: NavSection.WarehouseManagementSystem,
    },
    microstoreColumnGroupDetails: {
        icon: <FcDataRecovery />,
        label: "Détails des colonnes d'un microstore",
        section: PageName.microstoreColumnGroups,
        url: '/microstore-column-groups/:siteId',
        permission: TotadminPermission.MicrostoreColumnGroupsRead,
        alsoRequires: [TotadminPermission.SitesRead],
    },
    microstoreColumnGroupTargetsInfo: {
        icon: <FcDataRecovery />,
        label: 'Remplissage des stocks cibles des microstores',
        section: PageName.microstoreColumnGroups,
        url: '/microstore-column-groups/targets-info',
        permission: TotadminPermission.MicrostoreColumnGroupsRead,
        alsoRequires: [TotadminPermission.SitesRead],
    },
    microstoreColumnTemplates: {
        icon: <FcDataConfiguration />,
        label: 'Templates de colonne microstore',
        section: PageName.microstoreColumnTemplates,
        shortLabel: 'MS Cl. Templates',
        url: '/microstore-column-templates',
        permission: TotadminPermission.ColumnTemplatesRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    microstoreColumnTemplateDetails: {
        icon: <FcDataConfiguration />,
        label: "Détails d'un template de colonne microstore",
        section: PageName.microstoreColumnTemplates,
        url: '/microstore-column-template/:microstoreColumnTemplateId',
        permission: TotadminPermission.ColumnTemplatesRead,
    },
    microstorePlanogram: {
        icon: <GrPlan />,
        label: 'Planogramme',
        section: PageName.microstoreColumnGroups,
        url: '/planogram/:siteId',
        permission: TotadminPermission.MicrostoreColumnsRead,
    },
    microstoreSnapshot: {
        icon: <FcDataRecovery />,
        label: 'Snapshot Microstore',
        section: PageName.microstoreSnapshot,
        url: '/microstore-snapshot/:siteId',
        permission: TotadminPermission.SitesRead,
    },
    mobilePopups: {
        icon: <FcDataRecovery />,
        label: 'Popups mobile',
        section: PageName.mobilePopups,
        url: '/mobile-popups',
        permission: TotadminPermission.NotificationsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    nayaxMDBTemplates: {
        icon: <FcShop />,
        label: 'Templates MDB Nayax',
        section: PageName.nayaxMDBTemplates,
        url: '/nayax-mdb-templates',
        permission: TotadminPermission.NayaxTemplatesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    nayaxMDBTemplateDetails: {
        icon: <FcShop />,
        label: "Détails d'un template MDB Nayax",
        section: PageName.nayaxMDBTemplates,
        url: '/nayax-mdb-template/:nayaxMDBTemplateId',
        permission: TotadminPermission.NayaxTemplatesRead,
    },
    notifications: {
        icon: <FcInvite />,
        label: 'Notifications',
        section: PageName.notifications,
        url: '/notifications',
        permission: TotadminPermission.NotificationsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    notificationsOrganization: {
        icon: <FcInvite />,
        label: 'Notifier une organisation',
        section: PageName.notifications,
        url: '/notifications/organization',
        permission: TotadminPermission.NotificationsSend,
    },
    notificationsSite: {
        icon: <FcInvite />,
        label: 'Notifier un site',
        section: PageName.notifications,
        url: '/notifications/site',
        permission: TotadminPermission.NotificationsSend,
    },
    notificationsUser: {
        icon: <FcInvite />,
        label: 'Notifier un utilisateur',
        section: PageName.notifications,
        url: '/notifications/user',
        permission: TotadminPermission.NotificationsSend,
    },
    opsParameters: {
        icon: <FcSettings />,
        label: 'Paramètres Ops',
        section: PageName.opsParameters,
        url: '/ops-parameters',
        permission: TotadminPermission.OpsParametersRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryZones: {
        icon: <FcInTransit />,
        label: 'Zones de livraison',
        section: PageName.deliveryZones,
        url: '/delivery-zones',
        permission: TotadminPermission.DeliveryZonesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    deliveryZoneDetails: {
        icon: <FcInTransit />,
        label: 'Zone de livraison',
        section: PageName.deliveryZones,
        url: '/delivery-zone/:deliveryZoneId',
        permission: TotadminPermission.DeliveryZonesRead,
    },
    orders: {
        icon: <FcPaid />,
        label: 'Commandes',
        section: PageName.orders,
        url: '/orders',
        permission: TotadminPermission.OrdersRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    orderCreate: {
        icon: <FcPaid />,
        label: 'Créer une commande',
        section: PageName.orders,
        url: '/order/create',
        permission: TotadminPermission.OrdersManage,
    },
    orderDetails: {
        icon: <FcPaid />,
        label: "Détails d'une commande",
        section: PageName.orders,
        url: '/order/:orderId',
        permission: TotadminPermission.OrdersRead,
    },
    organizations: {
        icon: <FcOrganization />,
        label: 'Organisations',
        section: PageName.organizations,
        url: '/organizations',
        permission: TotadminPermission.OrganizationsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    organizationCreate: {
        icon: <FcOrganization />,
        label: 'Créer une organisation',
        section: PageName.organizations,
        url: '/organization/create',
        permission: TotadminPermission.OrganizationsManage,
    },
    organizationDetails: {
        icon: <FcOrganization />,
        label: "Détails d'une organisation",
        section: PageName.organizations,
        url: '/organization/:organizationId',
        permission: TotadminPermission.OrganizationsRead,
    },
    totems: {
        icon: <FcOrganization />,
        label: 'Totems',
        section: PageName.totems,
        shortLabel: 'Totems',
        url: '/totems',
        permission: TotadminPermission.TotemsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    totemDetails: {
        icon: <FcOrganization />,
        label: "Détails d'un totem",
        section: PageName.totemDetails,
        url: '/totem/:totemId',
        permission: TotadminPermission.TotemsRead,
    },
    microstoreColumnGroupPage: {
        icon: <FcDataRecovery />,
        label: "Détails d'un groupe de colonnes",
        section: PageName.microstoreColumnGroupPage,
        url: '/microstore-column-group/:columnGroupId',
        permission: TotadminPermission.MicrostoreColumnGroupsRead,
    },
    polls: {
        icon: <FcBarChart />,
        label: 'Sondages',
        section: PageName.polls,
        url: '/polls',
        permission: TotadminPermission.PollsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    pollCreate: {
        icon: <FcBarChart />,
        label: 'Créer un sondage',
        section: PageName.polls,
        url: '/poll/create',
        permission: TotadminPermission.PollsManage,
    },
    pollDetails: {
        icon: <FcBarChart />,
        label: "Détails d'un sondage",
        section: PageName.polls,
        url: '/poll/:pollId',
        permission: TotadminPermission.PollsRead,
    },
    products: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Produits',
        section: PageName.products,
        url: '/products',
        permission: TotadminPermission.ProductsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    productCreate: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Créer un produit',
        section: PageName.products,
        url: '/product/create',
        permission: TotadminPermission.ProductsManage,
    },
    productDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'un produit",
        section: PageName.products,
        url: '/product/:productId',
        permission: TotadminPermission.ProductsRead,
    },
    productImport: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Imports CSV de produit',
        section: PageName.products,
        url: '/product/imports',
        permission: TotadminPermission.ProductsManage,
    },
    productGroups: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Regroupements de produits',
        section: PageName.productGroups,
        url: '/product-groups',
        permission: TotadminPermission.ProductGroupsRead,
    },
    productGroupDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'un regroupement de produits",
        section: PageName.productGroups,
        url: '/product-group/:productGroupId',
        permission: TotadminPermission.ProductGroupsRead,
    },
    productArrangements: {
        icon: <FaAppleAlt color={colors.red} />,
        label: 'Gamme de produit',
        section: PageName.productArrangements,
        url: '/product-arrangements',
        permission: TotadminPermission.ProductArrangementsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    productArrangementDetails: {
        icon: <FaAppleAlt color={colors.red} />,
        label: "Détails d'une gamme de produit",
        section: PageName.productArrangements,
        url: '/product-arrangement/:productArrangementId',
        permission: TotadminPermission.ProductArrangementsRead,
    },
    permissionGroups: {
        icon: <FcKey />,
        label: 'Groupes de permissions',
        section: PageName.permissionGroups,
        url: '/permission-groups',
        permission: TotadminPermission.UsersRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    permissionGroupDetails: {
        icon: <FcKey />,
        label: 'Groupe de permissions',
        section: PageName.permissionGroups,
        url: '/permission-group/:slug',
        permission: TotadminPermission.UsersRead,
    },
    priceInvisibilityRules: {
        icon: <FcMoneyTransfer />,
        label: 'Prix masqués',
        section: PageName.priceInvisibilityRules,
        url: '/price-invisibility-rules',
        permission: TotadminPermission.PriceInvisibilityRulesRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    priceInvisibilityRuleDetails: {
        icon: <FcMoneyTransfer />,
        label: "Règle d'invisibilité des prix",
        section: PageName.priceInvisibilityRules,
        url: '/price-invisibility-rule/:priceInvisibilityRuleId',
        permission: TotadminPermission.PriceInvisibilityRulesRead,
    },
    productPriceRanges: {
        icon: <FcMoneyTransfer />,
        label: 'Gammes de prix',
        section: PageName.productPriceRanges,
        url: '/product-price-ranges',
        permission: TotadminPermission.PriceRangesRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    productPriceRangeCreate: {
        icon: <FcMoneyTransfer />,
        label: 'Créer une gamme de prix',
        section: PageName.productPriceRanges,
        url: '/product-price-range/create',
        permission: TotadminPermission.PriceRangesManage,
    },
    productPriceRangeDetails: {
        icon: <FcMoneyTransfer />,
        label: "Détails d'une gamme de prix",
        section: PageName.productPriceRanges,
        url: '/product-price-range/:rangeId',
        permission: TotadminPermission.PriceRangesRead,
    },
    quizzes: {
        icon: <BsFillQuestionDiamondFill />,
        label: 'Quiz',
        section: PageName.quizzes,
        url: '/quizzes',
        permission: TotadminPermission.PollsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    quizCreate: {
        icon: <BsFillQuestionDiamondFill />,
        label: 'Créer un quiz',
        section: PageName.quizzes,
        url: '/quiz/create',
        permission: TotadminPermission.PollsManage,
    },
    quizDetails: {
        icon: <BsFillQuestionDiamondFill />,
        label: "Détails d'un quiz",
        section: PageName.quizzes,
        url: '/quiz/:quizId',
        permission: TotadminPermission.PollsRead,
    },
    ritualCreate: {
        icon: <FcPlanner />,
        label: 'Créer un rituel',
        section: PageName.rituals,
        url: '/ritual/create',
        permission: TotadminPermission.RitualsManage,
    },
    ritualDetails: {
        icon: <FcPlanner />,
        label: "Détails d'un rituel",
        section: PageName.rituals,
        url: '/ritual/:ritualId',
        permission: TotadminPermission.RitualsRead,
    },
    rituals: {
        icon: <FcPlanner />,
        label: 'Rituels',
        section: PageName.rituals,
        url: '/rituals',
        permission: TotadminPermission.RitualsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    ritualTemplates: {
        icon: <FcStackOfPhotos />,
        label: 'Rituels (Modèles)',
        section: PageName.ritualTemplates,
        url: '/ritual-templates',
        permission: TotadminPermission.RitualsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    settings: {
        icon: <FcSettings />,
        label: 'Paramètres',
        section: PageName.settings,
        url: '/settings',
        permission: TotadminPermission.TotadminAccess,
    },
    sites: {
        icon: <FcShop />,
        label: 'Sites',
        section: PageName.sites,
        url: '/sites',
        permission: TotadminPermission.SitesRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    siteCreate: {
        icon: <FcShop />,
        label: 'Créer un site',
        section: PageName.sites,
        url: '/site/create',
        permission: TotadminPermission.SitesManage,
    },
    siteImport: {
        icon: <FcShop />,
        label: 'Imports CSV de site',
        section: PageName.sites,
        url: '/site/imports',
        permission: TotadminPermission.SitesManage,
    },
    siteDetails: {
        icon: <FcShop />,
        label: "Détails d'un site",
        section: PageName.sites,
        url: '/site/:siteId',
        permission: TotadminPermission.SitesRead,
    },
    siteMicrostoreColumnGroups: {
        icon: <FcDataRecovery />,
        label: 'Arborescence des groupes microstore',
        section: PageName.sites,
        url: '/site/:siteId/microstore-column-groups',
        permission: TotadminPermission.MicrostoreColumnGroupsRead,
        alsoRequires: [TotadminPermission.SitesRead],
    },
    siteExternalInventory: {
        icon: <FcShop />,
        label: 'Ventes Connues Site',
        section: PageName.siteExternalInventory,
        url: '/site-known-sales-inventory',
        permission: TotadminPermission.SiteInventoriesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    siteSetups: {
        icon: <RiFridgeFill />,
        label: 'Rangement des sites',
        shortLabel: 'Rangement Sites',
        section: PageName.siteSetups,
        url: '/site-setups',
        permission: TotadminPermission.SiteSetupsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    siteSetupDetails: {
        icon: <RiFridgeFill />,
        label: 'Rangement du site',
        section: PageName.siteSetups,
        url: '/site-setup/:siteSetupId',
        permission: TotadminPermission.SiteSetupsRead,
    },
    mealPlanDefinitions: {
        icon: <FaUtensils color={colors.yellow} />,
        label: 'Formules',
        section: PageName.mealPlanDefinitions,
        url: '/meal-plan-definitions',
        permission: TotadminPermission.MealPlanDefinitionsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    mealPlanDefinitionCreate: {
        icon: <FaUtensils color={colors.yellow} />,
        label: 'Créer une formule',
        section: PageName.mealPlanDefinitions,
        url: '/meal-plan-definition/create',
        permission: TotadminPermission.MealPlanDefinitionsManage,
    },
    mealPlanDefinitionDetails: {
        icon: <FaUtensils color={colors.yellow} />,
        label: "Détails d'une formule",
        section: PageName.mealPlanDefinitions,
        url: '/meal-plan-definition/:mealPlanDefinitionId',
        permission: TotadminPermission.MealPlanDefinitionsRead,
    },
    subventions: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Subventions',
        section: PageName.subventions,
        url: '/subventions',
        permission: TotadminPermission.SubventionsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    subventionCreate: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Créer une subvention',
        section: PageName.subventions,
        url: '/subvention/create',
        permission: TotadminPermission.SubventionsManage,
    },
    subventionDetails: {
        icon: <FaHandshake color={colors.yellow} />,
        label: "Détails d'une subvention",
        section: PageName.subventions,
        url: '/subvention/:subventionId',
        permission: TotadminPermission.SubventionsRead,
    },
    suppliers: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Fournisseurs',
        section: PageName.suppliers,
        url: '/suppliers',
        permission: TotadminPermission.SuppliersRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    supplierCreate: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Créer un fournisseur',
        section: PageName.suppliers,
        url: '/supplier/create',
        permission: TotadminPermission.SuppliersManage,
    },
    supplierDetails: {
        icon: <FaHandshake color={colors.yellow} />,
        label: "Détail d'un fournisseur",
        section: PageName.suppliers,
        url: '/supplier/:supplierId',
        permission: TotadminPermission.SuppliersRead,
    },
    supplyOrders: {
        icon: <FaTruckLoading color={colors.blue} />,
        label: 'Achats',
        section: PageName.supplyOrders,
        url: '/supply-orders',
        permission: TotadminPermission.SupplyOrdersRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    supplyOrderDetails: {
        icon: <FaTruckLoading color={colors.blue} />,
        label: "Détails d'un achat",
        section: PageName.supplyOrders,
        url: '/supply-order/:supplyOrderId',
        permission: TotadminPermission.SupplyOrdersRead,
    },
    supplyOrderConfirmation: {
        icon: <FaHandshake color={colors.blue} />,
        label: "Confirmation de commande d'achat",
        section: PageName.supplyOrderConfirmation,
        url: '/supply-order-confirmation/:token',
        permission: null,
    },
    supplierDiscounts: {
        icon: <FaHandshake color={colors.yellow} />,
        label: 'Remises fournisseurs',
        section: PageName.supplierDiscounts,
        url: '/supplier-discounts',
        permission: TotadminPermission.SupplierDiscountsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    stockTransfers: {
        icon: <FcNeutralTrading />,
        label: 'Transferts de stock',
        section: PageName.stockTransfers,
        url: '/stock-transfers',
        permission: TotadminPermission.StockTransfersRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    stockTransferCreate: {
        icon: <FcNeutralTrading />,
        label: 'Créer un transfert de stock',
        section: PageName.stockTransfers,
        url: '/stock-transfer/create',
        permission: TotadminPermission.StockTransfersManage,
    },
    stockTransferDetails: {
        icon: <FcNeutralTrading />,
        label: "Détails d'un transfert de stock",
        section: PageName.stockTransfers,
        url: '/stock-transfer/:stockTransferId',
        permission: TotadminPermission.StockTransfersRead,
    },
    stockTransferReturns: {
        icon: <FcNeutralTrading />,
        label: "Consulter les retours à l'entrepôt",
        section: PageName.stockTransfers,
        url: '/stock-transfer/returns',
        permission: TotadminPermission.StockTransfersRead,
    },
    stocks: {
        icon: <FcAreaChart />,
        label: 'Stocks',
        section: PageName.stocks,
        url: '/stocks',
        permission: TotadminPermission.StockVariationsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    stockVariationsByDay: {
        icon: <FcAreaChart />,
        label: 'Variations de stock par jour',
        section: PageName.stockVariationsByDay,
        url: '/stock-variations-by-day',
        permission: TotadminPermission.StockVariationsRead,
        // Les variations sont clés par colonne : la page résout colonne -> site via `columns`.
        alsoRequires: [TotadminPermission.MicrostoreColumnsRead],
    },
    siteStocks: {
        icon: <FcAreaChart />,
        label: 'Colonnes du site',
        section: PageName.stocks,
        url: '/site/:siteId/stocks',
        permission: TotadminPermission.StockVariationsRead,
        alsoRequires: [TotadminPermission.SitesRead, TotadminPermission.MicrostoreColumnsRead],
    },
    columnStocks: {
        icon: <FcAreaChart />,
        label: 'Stocks de la colonne',
        section: PageName.stocks,
        url: '/column/:columnId/stocks',
        permission: TotadminPermission.StockVariationsRead,
        alsoRequires: [TotadminPermission.MicrostoreColumnsRead],
    },
    columnProductStocks: {
        icon: <FcAreaChart />,
        label: 'Historique de stock du produit',
        section: PageName.stocks,
        url: '/column/:columnId/stocks/:productId',
        permission: TotadminPermission.StockVariationsRead,
        alsoRequires: [TotadminPermission.MicrostoreColumnsRead],
    },
    siteInventoryStockCreate: {
        icon: <FcAreaChart />,
        label: 'Inventorier un produit',
        section: PageName.stocks,
        url: '/site-inventory-stock/create',
        permission: TotadminPermission.SiteInventoriesManage,
    },
    stockVariationCreate: {
        icon: <FcAreaChart />,
        label: 'Créer une variation de stock',
        section: PageName.stocks,
        url: '/stock-variation/create',
        permission: TotadminPermission.StockVariationsManage,
    },
    stockVariationMultiCreate: {
        icon: <FcAreaChart />,
        label: 'Créer des variations de stock',
        section: PageName.stocks,
        url: '/stock-variation/create/multi',
        permission: TotadminPermission.StockVariationsManage,
    },
    tags: {
        icon: <FcDonate />,
        label: 'Tags',
        section: PageName.tags,
        url: '/tags',
        permission: TotadminPermission.TagsRead,
        navSection: NavSection.CatalogManagementSystem,
    },
    tagCreate: {
        icon: <FcDonate />,
        label: 'Tag',
        section: PageName.tags,
        url: '/tag/create',
        permission: TotadminPermission.TagsManage,
    },
    tagUpdate: {
        icon: <FcDonate />,
        label: 'Tag',
        section: PageName.tags,
        url: '/tag/:tagId',
        permission: TotadminPermission.TagsRead,
    },
    tickets: {
        icon: <FcSms />,
        label: 'Tickets',
        section: PageName.tickets,
        url: '/tickets',
        permission: TotadminPermission.TicketsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    ticketDetails: {
        icon: <FcSms />,
        label: "Détail d'un ticket",
        section: PageName.tickets,
        url: '/ticket/:ticketId',
        permission: TotadminPermission.TicketsRead,
    },
    termsRecords: {
        icon: <FcNews />,
        label: 'CGV',
        section: PageName.termsRecords,
        url: '/terms-records',
        permission: TotadminPermission.TermsRecordsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    termsRecordCreate: {
        icon: <FcNews />,
        label: 'Créer une nouvelle version des CGV',
        section: PageName.termsRecords,
        url: '/terms-record/create',
        permission: TotadminPermission.TermsRecordsManage,
    },
    thermometers: {
        icon: <FaThermometerHalf />,
        label: 'Thermomètres',
        section: PageName.thermometers,
        url: '/thermometers',
        permission: TotadminPermission.ThermometersRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    audit: {
        icon: <FcInspection />,
        label: 'Audits',
        section: PageName.audit,
        url: '/audit',
        permission: TotadminPermission.AuditLogsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    auditDetails: {
        icon: <FcInspection />,
        label: 'Détail d’un audit',
        section: PageName.audit,
        url: '/audit/:auditLogId',
        permission: TotadminPermission.AuditLogsRead,
    },
    ntfy: {
        icon: <FcAdvertising />,
        label: 'Notifications ntfy',
        section: PageName.ntfy,
        url: '/ntfy',
        permission: TotadminPermission.NtfyRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    payments: {
        icon: <FcDebt />,
        label: 'Paiements',
        section: PageName.payments,
        url: '/payments',
        permission: TotadminPermission.TransactionsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    paymentDetails: {
        icon: <FcDebt />,
        label: "Détails d'un paiement",
        section: PageName.payments,
        url: '/payment/:paymentId',
        permission: TotadminPermission.TransactionsRead,
    },
    paymentMethodDetails: {
        icon: <FcDebt />,
        label: "Détails d'un moyen de paiement",
        section: PageName.payments,
        url: '/payment-method/:paymentMethodId',
        permission: TotadminPermission.TransactionsRead,
    },
    transactions: {
        icon: <FcCurrencyExchange />,
        label: 'Transactions',
        section: PageName.transactions,
        url: '/transactions',
        permission: TotadminPermission.TransactionsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    transactionCreate: {
        icon: <FcCurrencyExchange />,
        label: 'Créer une transaction',
        section: PageName.transactions,
        url: '/transaction/create',
        permission: TotadminPermission.TransactionsRefund,
    },
    transactionDetails: {
        icon: <FcCurrencyExchange />,
        label: "Détails d'une transaction",
        section: PageName.transactions,
        url: '/transaction/:transactionId',
        permission: TotadminPermission.TransactionsRead,
    },
    totemClosedDays: {
        icon: <FcCancel />,
        label: 'Jours de fermeture Totem',
        section: PageName.totemClosedDays,
        url: '/totem-closed-days',
        permission: TotadminPermission.TotemsRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    totemClosedReceptionDays: {
        icon: <FcCancel />,
        label: 'Jours de non-réception fresh Totem',
        section: PageName.totemClosedReceptionDays,
        url: '/totem-closed-reception-days',
        permission: TotadminPermission.TotemsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    urbantzRoundPresets: {
        icon: <IoBicycleOutline />,
        label: 'Tournées prédéfinies',
        section: PageName.urbantzRoundPresets,
        url: '/urbantz-round-presets',
        permission: TotadminPermission.ToursRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    users: {
        icon: <FcConferenceCall />,
        label: 'Utilisateurs',
        section: PageName.users,
        url: '/users',
        permission: TotadminPermission.UsersRead,
        navSection: NavSection.CustomerManagementSystem,
    },
    userCreateToteam: {
        icon: <FcConferenceCall />,
        label: 'Créer un utilisateur Toteam',
        section: PageName.users,
        url: '/user/create-toteam',
        permission: TotadminPermission.PermissionsManage,
    },
    userCreatedTotops: {
        icon: <FcConferenceCall />,
        label: 'Utilisateur Totops créé',
        section: PageName.users,
        url: '/user/created-totops',
        permission: TotadminPermission.PermissionsManage,
    },
    userDetails: {
        icon: <FcConferenceCall />,
        label: "Détails d'un utilisateur",
        section: PageName.users,
        url: '/user/:userId',
        permission: TotadminPermission.UsersRead,
    },
    setPassword: {
        label: 'Définir mon mot de passe',
        section: PageName.setPassword,
        url: '/set-password/:token',
        permission: null,
    },
    passwordDefined: {
        label: 'Mot de passe défini',
        section: PageName.passwordDefined,
        url: '/totops-password-defined',
        permission: null,
    },
    basket: {
        icon: <FcCurrencyExchange />,
        label: 'Panier',
        section: PageName.transactions,
        url: '/basket/:basketId',
        permission: TotadminPermission.TransactionsRead,
    },
    warehouseDeliveries: {
        icon: <FcInTransit />,
        label: 'Livraisons-entrepot',
        section: PageName.warehouseDeliveries,
        url: '/warehouse-deliveries',
        permission: TotadminPermission.WarehouseDeliveriesRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    warehouseDeliveryDetails: {
        icon: <FcInTransit />,
        label: 'Livraisons-entrepot',
        section: PageName.warehouseDeliveries,
        url: '/warehouse-delivery/:warehouseDeliveryId',
        permission: TotadminPermission.WarehouseDeliveriesRead,
    },
    warehouseReturns: {
        icon: <RiFridgeFill />,
        label: 'Retours Entrepôt',
        section: PageName.warehouseReturns,
        url: '/warehouse-returns',
        permission: TotadminPermission.WarehouseReturnsRead,
        navSection: NavSection.WarehouseManagementSystem,
    },
    warehouseReturnDetails: {
        icon: <RiFridgeFill />,
        label: 'Retour Entrepôt',
        section: PageName.warehouseReturns,
        url: '/warehouse-return/:warehouseReturnId',
        permission: TotadminPermission.WarehouseReturnsRead,
    },
};
